import React from "react";
import { FaMapMarkedAlt, FaPhoneAlt, FaRegClock, FaStar } from "react-icons/fa";
import adventure from '../assets/Adventure vs. Leisure_ Choosing Your Perfect Vacation.png'
export const FAQs = [
    { question: "Can members gift their holiday?", answer: " Member can gift their holiday." },
    { question: "Can members advance their holiday?", answer: " Member can advance their holiday." },
    { question: "Can members save their holiday?", answer: "Yes, Member can save their holiday." },
    { question: "Can members split their holiday?", answer: " Member can split their holiday." },
    { question: "Is membership transferable one time?", answer: " Membership is one time transferable." },
    { question: "Will membership nights be carried forward if not utilized?", answer: "Yes, you can save your holidays." },
    { question: "What are the membership tiers?", answer: "We offer Silver, Gold, and Platinum tiers with increasing benefits and exclusive perks." },
    { question: "In case of non-utilization, will nights be carried forward to the next year?", answer: "Yes, In-case of non-utilization, nights would be carry forwarded to the next year.." },
    { question: "Can I upgrade my membership?", answer: "Yes, you can upgrade your membership at any time to access more benefits." },

];


export const Plans = [
    {
        name: "Basic",
        duration: [{ years: "5 Years", price: " ₹150000" }, { years: "10 Years", price: "₹260000" }, { years: "15 Years", price: "₹350000" }, { years: "25 Years", price: "₹400000" }],
        propertyType: "3 ⭐ to 4 ⭐",
        capacity: "2 adults and 2 kids (under 5 years)",
        annualMaintenance: "₹9999/year",
    },
    {
        name: "Premium",
        duration: [{ years: "5 Years", price: "₹250000" }, { years: "10 Years", price: "₹340000" }, { years: "15 Years", price: "₹400000" }, { years: "25 Years", price: "₹510000" }],
        propertyType: "4 ⭐ to 5 ⭐",
        capacity: "2 adults and 2 kids (under 5 years)",
        annualMaintenance: "₹9999/year",
    },
    {
        name: "Elite",
        duration: [{ years: "5 Years", price: "₹300000" }, { years: "10 Years", price: "₹530000" }, { years: "15 Years", price: "₹700000" }, { years: "25 Years", price: "₹850000" }],
        propertyType: "4 ⭐ to 5 ⭐",
        capacity: "4 adults and 2 kids (under 5 years)",
        annualMaintenance: "₹9999/year",
    },
    {
        name: "Corporate",
        duration: [{ years: "5 Years", price: "₹1200000" }, { years: "10 Years", price: "₹2200000" }, { years: "15 Years", price: "₹3000000" }, { years: "25 Years", price: "₹3500000" }],
        propertyType: "4 ⭐ to 5 ⭐",
        capacity: "Up to 50 adults",
        annualMaintenance: "₹9999/year",
    },
];

export const steps = [
    {
        title: "Choose a Plan",
        description: "Select from our range of flexible membership plans that suit your needs.",
        icon: "https://via.placeholder.com/100", // You can replace this with real icons or images.
    },
    {
        title: "Add Your Personal Details",
        description: "Provide your personal details to complete your membership profile.",
        icon: "https://via.placeholder.com/100",
    },
    {
        title: "Get Help from Our Helpdesk",
        description: "Our support team is always available to assist you with any queries.",
        icon: "https://via.placeholder.com/100",
    },
    {
        title: "Select Best Offers & Packages",
        description: "Choose from a variety of travel packages and exclusive deals for members.",
        icon: "https://via.placeholder.com/100",
    },
    {
        title: "Complete Payment",
        description: "Complete your membership payment through our secure payment gateway.",
        icon: <FaStar className="text-yellow-500 text-4xl" />,
    },
    {
        title: "Enjoy Ultimate Experience",
        description: "Enjoy your stay at our luxurious resorts and taste the best cuisine.",
        icon: "https://via.placeholder.com/100",
    },
];

export const benefits = [
    {
        title: "Flexible Point-Based Booking",
        description: "Enjoy a flexible, point-based booking system that allows you to plan vacations as per your needs.",
        icon: <FaRegClock className="text-blue-500 text-4xl" />,
    },
    {
        title: "Easy Upgrades & Top-ups",
        description: "Upgrade your membership or top-up points at any time to get access to more destinations.",
        icon: <FaStar className="text-yellow-500 text-4xl" />,
    },
    {
        title: "150+ Resorts Across India",
        description: "Access over 100+ luxurious resorts spread across scenic locations in India.",
        icon: <FaMapMarkedAlt className="text-green-500 text-4xl" />,
    },
    {
        title: "24/7 Dedicated Helpdesk",
        description: "Our helpdesk is available 24x7 to assist you with bookings, upgrades, and more.",
        icon: <FaPhoneAlt className="text-red-500 text-4xl" />,
    },
];
export const giftCards = [
    {
      id: 1,
      image: 'https://i.pinimg.com/736x/0e/3e/b7/0e3eb7ae4eca1f4fcd37b10778333810.jpg',
      title: 'Beach Getaway',
      description: 'Relax and unwind at exotic beaches.',
    },
    {
      id: 2,
      image: 'https://i.pinimg.com/736x/23/c0/88/23c0883fa391b126e144748aad46b888.jpg',
      title: 'Mountain Retreat',
      description: 'Escape to serene mountain retreats.',
    },
    {
      id: 3,
      image: 'https://i.pinimg.com/736x/83/1a/04/831a04619490a1066dea3b39e0b65633.jpg',
      title: 'City Adventures',
      description: 'Discover urban landscapes and adventures.',
    },
    {
      id: 4,
      image: 'https://i.pinimg.com/736x/b4/86/15/b4861553bfcd3952c5e7ea374522f9be.jpg',
      title: 'Luxury Resorts',
      description: 'Enjoy luxury and elegance at our resorts.',
    },
    {
      id: 5,
      image: 'https://i.pinimg.com/736x/65/74/95/65749557d7b679c71223cf15cca7c32c.jpg',
      title: 'Family Adventures',
      description: 'Create unforgettable memories with family.',
    },
    {
      id: 6,
      image: 'https://i.pinimg.com/736x/b7/02/b1/b702b1f7cdad1232264f7bd15fcc7d4b.jpg',
      title: 'Weekend Getaways',
      description: 'Short escapes for rejuvenating weekends.',
    },
    {
      id: 7,
      image: 'https://i.pinimg.com/736x/84/20/04/84200405d4ce26385fe13f55f38a16fe.jpg',
      title: 'Graduation Treats',
      description: 'Celebrate achievements with travel gifts.',
    },
    {
      id: 8,
      image: 'https://i.pinimg.com/736x/ca/8a/ff/ca8aff57082b3a1d49f462acd434c270.jpg',
      title: 'Corporate Retreats',
      description: 'Reward your team with unforgettable retreats.',
    },
  ];
 
  export const newsAndEvents = [
    {
      id: 1,
      type: 'news',
      title: 'Discover New Beach Resorts in 2024',
      subTitle: 'New Beach Destinations Open for Tourists',
      date: '25 Dec 2024',
      time: '10:00 AM',
      category: 'Beach Travel',
      logo: 'https://i.pinimg.com/736x/4a/1f/75/4a1f75e222a59cdfa906c6bac692aa9a.jpg',
      description: 'Discover exciting new beach destinations perfect for your next vacation.'
      
    },
    {
      id: 2,
      type: 'event',
      title: 'Mountain Hiking Event - Jan 2024',
      subTitle: 'Mountain Retreats Now Offering Discounts',
      date: '15 Jan 2024',
      time: '9:00 AM',
      category: 'Adventure',
      logo: 'https://i.pinimg.com/736x/35/64/74/356474f9e08ee9382d3ac7edb9162376.jpg',
      description: 'Unwind at serene mountain retreats with great discounts this season.'
    },
    {
      id: 3,
      type: 'news',
      title: 'Luxury Cruise Packages Announced',
      subTitle: 'Luxury Cruise Packages Announced',
      date: '10 Dec 2024',
      time: '11:30 AM',
      category: 'Cruise',
      logo: 'https://i.pinimg.com/736x/a6/2e/32/a62e32f87b82eddaaefa4ba6050a6ec5.jpg',
      description: 'Join us for an unforgettable evening of music in the mountains.'
    },
    {
      id: 4,
      type: 'event',
      title: 'Desert Safari: Exclusive Night Camp',
      subTitle: 'New Beach Destinations Open for Tourists',
      date: '20 Jan 2024',
      time: '5:00 PM',
      category: 'Desert',
      logo: 'https://i.pinimg.com/736x/a3/9f/13/a39f1399be4a73d23bb183fe68ca1030.jpg',
      description: 'Join us for an unforgettable evening of music in the mountains.'
    },
    {
      id: 5,
      type: 'news',
      title: 'Top 10 Travel Destinations for 2024',
      subTitle: 'New Beach Destinations Open for Tourists',
      date: '5 Jan 2024',
      time: '3:00 PM',
      category: 'Travel Tips',
      logo: 'https://i.pinimg.com/736x/02/b7/2d/02b72d07cc78e61dc75722f0b2367b86.jpg',
      description: 'Join us for an unforgettable evening of music in the mountains.'
    },
    {
      id: 6,
      type: 'event',
      title: 'Cultural Festival in Europe',
      subTitle: 'New Beach Destinations Open for Tourists',
      date: '30 Dec 2024',
      time: '7:00 PM',
      category: 'Culture',
      logo: 'https://i.pinimg.com/736x/8d/9c/1a/8d9c1a2bf4ad87655791770870b37f29.jpg',
      description: 'Ring in the New Year with a spectacular beach celebration.'
    },
  ];

  //blog data 

  // blogData.js
export const blogPosts = [
  {
    id: "1",
    slug: "Adventure vs. Leisure_ Choosing Your Perfect Vacation",
    title: "Adventure vs. Leisure_ Choosing Your Perfect Vacation",
    metaDescription: "Explore India's hidden travel gems beyond the crowds! Plan your trip with the Top 10 travel agency in Delhi or the Best travel agency in Delhi for international Tours.",
    thumbnail: "/assets/Adventure vs. Leisure_ Choosing Your Perfect Vacation.png",
    content: `India is a land of diverse landscapes, rich history, and breathtaking natural beauty...`, // full blog content
  },
  {
    id: "2",
    slug: "travel-checklist-international-tour",
    title: "Your Ultimate Travel Checklist for International Tours",
    metaDescription: "Don’t miss anything on your next international trip. Here’s a comprehensive travel checklist curated by the best travel agency in Delhi.",
    thumbnail: "/images/blog2.jpg",
    content: "Coming soon...", // replace with full content
  },
  {
    id: "3",
    slug: "budget-friendly-honeymoon-destinations",
    title: "Top 5 Budget-Friendly Honeymoon Destinations",
    metaDescription: "Plan a dreamy honeymoon without breaking the bank! Discover budget destinations with Pravasa.in’s expert travel planners.",
    thumbnail: "/images/blog3.jpg",
    content: "Coming soon...", // replace with full content
  }
];

let blogJson = {
  "HiddenDestinations": {
    "blogImg": "\"\"",
    "hiddenDestinations": {
      "Chandrapur": {
        "description": "A lesser-known wildlife destination, Chandrapur is home to the Tadoba-Andhari Tiger Reserve. With diverse flora and fauna, it’s a great destination for wildlife enthusiasts.",
        "state": "Maharashtra"
      },
      "Chettinad": {
        "description": "Famous for its heritage mansions, intricate architecture, and flavorful cuisine, Chettinad offers a glimpse into South India’s regal past. The region’s ancient temples and unique culture make it a hidden treasure.",
        "state": "Tamil Nadu"
      },
      "Chopta": {
        "description": "Known as the ‘Mini Switzerland of India,’ Chopta is a scenic hill station perfect for trekking enthusiasts. It serves as the base for the Tungnath Temple, the highest Shiva temple in the world.",
        "state": "Uttarakhand"
      },
      "Gokarna": {
        "description": "Often called the 'quieter Goa,' Gokarna boasts pristine beaches like Om Beach, Kudle Beach, and Half Moon Beach. This coastal town is a perfect blend of spirituality and relaxation.",
        "state": "Karnataka"
      },
      "Majuli": {
        "description": "Majuli, the world's largest river island, is an unexplored wonder in Assam. This tranquil island is home to vibrant Satras (Vaishnavite monasteries), lush green landscapes, and a unique culture shaped by the Brahmaputra River.",
        "state": "Assam"
      },
      "Mawlynnong": {
        "description": "Titled ‘Asia’s Cleanest Village,’ Mawlynnong is a charming destination with lush greenery, bamboo houses, and the iconic living root bridges. It’s a perfect getaway for eco-tourism lovers.",
        "state": "Meghalaya"
      },
      "Sandakphu": {
        "description": "For breathtaking Himalayan views, Sandakphu is a hidden treasure. The highest peak in West Bengal, it offers stunning views of the Everest, Kanchenjunga, Lhotse, and Makalu peaks.",
        "state": "West Bengal"
      },
      "SpitiValley": {
        "description": "For those seeking adventure, Spiti Valley is an untouched wonder with high-altitude monasteries, rugged landscapes, and breathtaking views. It’s a dream destination for bikers and trekkers.",
        "state": "Himachal Pradesh"
      },
      "Tawang": {
        "description": "Nestled in the eastern Himalayas, Tawang is a paradise for nature lovers and spiritual seekers. The serene Tawang Monastery, mesmerizing Nuranang Falls, and the picturesque Sela Pass make it a must-visit destination.",
        "state": "Arunachal Pradesh"
      },
      "ZiroValley": {
        "description": "A UNESCO World Heritage nominee, Ziro Valley is known for its rolling green hills, rice fields, and the indigenous Apatani tribe. The annual Ziro Music Festival attracts music lovers from around the world.",
        "state": "Arunachal Pradesh"
      }
    },
    "travelAgency": {
      "Pravasa": {
        "description": "Pravasa.in is an excellent travel partner offering curated experiences tailored to your needs. Whether you seek hidden gems or popular destinations, their expertise ensures a seamless travel experience.",
        "location": "Delhi",
        "registeredAgents": true,
        "services": [
          "Well-planned itineraries",
          "Personalized recommendations",
          "Hassle-free bookings"
        ]
      },
      "topAgenciesDelhi": [
        "Top 10 travel agency in Delhi",
        "Best travel agency in Delhi for international tours"
      ]
    }
  },
  "friendlyTrip": {
    "blogImg": "\"\"",
    "destinations": {
      "bhutan": {
        "budgetTips": [
          "Affordable accommodations",
          "Local food"
        ],
        "highlights": [
          "Paro",
          "Thimphu",
          "Punakha"
        ],
        "imageUrl": "",
        "name": "Bhutan",
        "visaInfo": "No visa required for Indians"
      },
      "dubai": {
        "budgetTips": [
          "Budget airlines deals",
          "Affordable accommodations in Deira/Bur Dubai"
        ],
        "highlights": [
          "Dubai Fountain",
          "Dubai Marina"
        ],
        "imageUrl": "",
        "name": "Dubai (UAE)",
        "visaInfo": "Visa required (Easy process for Indians)"
      },
      "indonesia": {
        "budgetTips": [
          "Budget hotels",
          "Scooter rentals",
          "Cheap local food"
        ],
        "highlights": [
          "Temples",
          "Waterfalls",
          "Beaches"
        ],
        "imageUrl": "",
        "name": "Indonesia (Bali)",
        "visaInfo": "Visa-free entry for Indians (up to 30 days)"
      },
      "malaysia": {
        "budgetTips": [
          "Cheap public transport",
          "Budget accommodations"
        ],
        "highlights": [
          "Kuala Lumpur",
          "Langkawi",
          "Penang"
        ],
        "imageUrl": "",
        "name": "Malaysia",
        "visaInfo": "eVisa available"
      },
      "nepal": {
        "budgetTips": [
          "Affordable guesthouses",
          "Local eateries"
        ],
        "highlights": [
          "Kathmandu",
          "Pokhara",
          "Everest Base Camp treks"
        ],
        "imageUrl": "",
        "name": "Nepal",
        "visaInfo": "No passport required (Government-issued ID accepted for Indians)"
      },
      "philippines": {
        "budgetTips": [
          "Cheap hostels",
          "Budget-friendly street food"
        ],
        "highlights": [
          "Palawan",
          "Cebu",
          "Boracay"
        ],
        "imageUrl": "",
        "name": "Philippines",
        "visaInfo": "Visa required (Relatively easy to obtain)"
      },
      "sriLanka": {
        "budgetTips": [
          "Local food",
          "Affordable guesthouses"
        ],
        "highlights": [
          "Beaches of Bentota",
          "Tea plantations in Nuwara Eliya",
          "Historic city of Galle"
        ],
        "imageUrl": "",
        "name": "Sri Lanka",
        "visaInfo": "ETA (Electronic Travel Authorization) required"
      },
      "thailand": {
        "budgetTips": [
          "Street food",
          "Budget accommodations",
          "Local transport"
        ],
        "highlights": [
          "Bangkok",
          "Pattaya",
          "Phuket",
          "Chiang Mai"
        ],
        "imageUrl": "",
        "name": "Thailand",
        "visaInfo": "Visa-on-arrival facility for Indians"
      },
      "turkey": {
        "budgetTips": [
          "Budget accommodations",
          "Local cuisine"
        ],
        "highlights": [
          "Istanbul",
          "Cappadocia",
          "Pamukkale"
        ],
        "imageUrl": "",
        "name": "Turkey",
        "visaInfo": "e-Visa available"
      },
      "vietnam": {
        "budgetTips": [
          "Cheap internal transport",
          "Inexpensive street food"
        ],
        "highlights": [
          "Hanoi",
          "Ho Chi Minh",
          "Da Nang"
        ],
        "imageUrl": "",
        "name": "Vietnam",
        "visaInfo": "Visa-on-arrival process"
      }
    },
    "lastUpdated": "TIMESTAMP",
    "meta": {
      "description": "Explore the best budget-friendly international trips for Indians. Get affordable travel options with expert guidance from registered travel agents in Delhi.",
      "title": "Best Budget-Friendly International Trips for Indians"
    },
    "travelAgency": {
      "description": "Registered travel agents in Delhi offering budget-friendly international tour packages",
      "name": "Pravasa.in",
      "services": [
        "Customized tour packages",
        "Expert guidance",
        "Cost-effective solutions"
      ],
      "tags": [
        "Top 10 travel agency in Delhi",
        "Best travel agency in Delhi",
        "Travel agency Delhi near me"
      ]
    }
  },
  "vacation_guide": {
    "adventure_travel": {
      "benefits": {
        "adrenaline_rush": "Activities like skydiving, white-water rafting, and bungee jumping create unforgettable moments.",
        "cultural_exposure": "Adventure trips often lead to remote locations, offering deeper insights into local traditions and lifestyles.",
        "personal_growth": "Overcoming challenges, whether climbing a peak or diving into the ocean, builds resilience and confidence."
      },
      "description": "Adventure travel is for those who seek excitement and love to push their limits. It often includes physically demanding activities such as trekking, scuba diving, paragliding, or wildlife safaris. These experiences provide an unmatched sense of accomplishment and an opportunity to explore breathtaking landscapes.",
      "destinations": [
        {
          "activities": [
            "river rafting",
            "cliff jumping",
            "bungee jumping"
          ],
          "name": "Rishikesh, India"
        },
        {
          "activities": [
            "road trips",
            "treks",
            "biking adventures"
          ],
          "name": "Leh-Ladakh"
        },
        {
          "activities": [
            "skiing",
            "paragliding",
            "hiking in the Alps"
          ],
          "name": "Switzerland"
        },
        {
          "activities": [
            "skydiving",
            "canyoning",
            "extreme sports"
          ],
          "name": "New Zealand"
        }
      ]
    },
    "blogImg": "\"gs://pravasa-ef1a9.firebasestorage.app/Adventure vs. Leisure_ Choosing Your Perfect Vacation.png\"",
    "conclusion": "Adventure and leisure travel cater to different preferences, but both offer enriching experiences. While thrill-seekers enjoy heart-pounding activities, relaxation lovers cherish peaceful getaways. With the right travel partner like Pravasa.in, you can craft a vacation that perfectly suits your style—whether it's an action-packed journey or a tranquil retreat.",
    "hybrid_travel": {
      "description": "Sometimes, the best vacation combines elements of both adventure and leisure. Choosing a balanced itinerary allows you to explore exciting adventures while enjoying moments of peace.",
      "destinations": [
        "Thailand",
        "Spain",
        "Australia"
      ]
    },
    "introduction": "Planning a vacation comes with one big question—should you go for an adrenaline-filled adventure or a relaxing leisure trip? Both types of vacations offer unique experiences, catering to different personalities, moods, and travel goals. Whether you dream of hiking rugged mountains or unwinding by the beach, your choice will shape your travel memories.",
    "leisure_travel": {
      "benefits": {
        "quality_time": "Perfect for family vacations, romantic getaways, or solo retreats.",
        "rejuvenation": "Ideal for unwinding at spas, beaches, or cozy mountain resorts.",
        "stress_free": "No rigid itineraries, just peaceful sightseeing and relaxation."
      },
      "description": "Leisure vacations are designed for relaxation and rejuvenation. These trips focus on comfort, slow-paced exploration, and unwinding at scenic locations. Whether it's a beach retreat, a cultural city tour, or a luxury resort stay, leisure travel is all about indulgence.",
      "destinations": [
        {
          "highlights": [
            "overwater villas",
            "white sandy beaches",
            "clear blue waters"
          ],
          "name": "Maldives"
        },
        {
          "highlights": [
            "art & history",
            "luxury shopping",
            "cultural experiences"
          ],
          "name": "Paris, France"
        },
        {
          "highlights": [
            "beaches",
            "seafood",
            "nightlife"
          ],
          "name": "Goa, India"
        },
        {
          "highlights": [
            "yoga retreats",
            "serene landscapes",
            "cultural sites"
          ],
          "name": "Bali, Indonesia"
        }
      ]
    },
    "meta": {
      "description": "Adventure or leisure? Discover the perfect vacation for you. Plan stress-free with a registered travel agent in Delhi. Find the best travel agency for international tours.",
      "title": "Adventure vs. Leisure: Choosing Your Perfect Vacation"
    },
    "travel_agency_info": {
      "description": "A registered travel agent in Delhi, such as Pravasa.in, ensures a hassle-free experience by offering customized itineraries, the best deals, and seamless booking services.",
      "search_terms": [
        "Top 10 travel agency in Delhi",
        "Delhi travel agency list",
        "travel agency in Delhi near me",
        "best travel agency in Delhi"
      ]
    }
  }
}
// export const blogData = JSON.parse(blogJson);

